import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { message } from 'antd';
import { Button } from 'antd-v5';
import { API_URL } from '../../../../../../constants';
import PaymentRequestCard from './components/PaymentRequestCard';
import './styles.css';

const PaymentRequest = props => {
  const { setViewAllType, showMessageHandler } = props;

  const [loading, setLoading] = useState(false);
  const [paymentRequests, setPaymentRequests] = useState([]);

  const fetchPaymentRequests = useCallback(async () => {
    if(props.client.client_id) {
      setLoading(true);

      try {
        const response = await axios.get(`${API_URL}/xa/clients/${props.client.client_id}/payment-requests`, {
          params: {
            page: 1,
            pageSize: 2,
          },
        });
        setPaymentRequests(response.data.results);
      } catch (error) {
        if(error?.response?.data?.message === "Client not found") {
          setPaymentRequests([]);
        } else {
          console.log('Error Fetching Payment Requests', error);
          message.error('Error Fetching Payment Requests');
        }
      } finally {
        setLoading(false);
      }
    }
  }, [props.client.client_id]);

  useEffect(() => {
    fetchPaymentRequests();
  }, [props.client.client_id]);

  return (
    <div className="qv-section qv-section--payment">
      <div className="qv-section-header">
        <h3 className="qv-section-title">Payment Request</h3>

        <Button
          type="link"
          onClick={() => {
            setViewAllType('allPaymentRequests');
          }}
          className="cb-link-btn"
        >
          View All
        </Button>
      </div>

      <div className="qv-section-body">
        {loading && <div className="qv-section-empty">Loading...</div>}

        {!loading && !paymentRequests.length && (
          <div className="qv-section-empty">No payment history available</div>
        )}

        {!loading &&
          Boolean(paymentRequests.length) &&
          paymentRequests.map(item => (
            <PaymentRequestCard key={item.id} paymentRequest={item} onClick={showMessageHandler} />
          ))}
      </div>
    </div>
  );
};
export default PaymentRequest;
